/**
 * useAppTheme — convenience hook
 * Returns the MUI theme and the current color token set in one call.
 *
 * Usage:
 *   const { theme, C } = useAppTheme();
 *   // C.bull, C.bear, C.chartGrid, etc.
 */
import { useTheme } from '@mui/material/styles';
import { tokens, AppColorTokens } from '../styles/colorTokens';

interface AppTheme {
  theme: ReturnType<typeof useTheme>;
  C: AppColorTokens;
  isDark: boolean;
}

export function useAppTheme(): AppTheme {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const C = tokens[theme.palette.mode as 'light' | 'dark'];
  return { theme, C, isDark };
}
